import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import * as home from '../../app/modules/homescreen/HomeRedux'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  home: home.reducer
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga(), home.saga()])
}
